import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './auth/login/login.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { JwtModule } from '@auth0/angular-jwt';
import { environment } from '@environments/environment';
import { AuthModule } from './auth/auth.module';
import { SharedModule } from './shared/shared.module';
import { MainModule } from './components/main/main.module';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { ApiMissingTranslationHandler } from './shared/apiMissingTranslationHandler';
import { ApiTranslateLoader } from './shared/apiTranslationLoader';
import { appInitializerProviders } from './shared/apiInitializerProviders';
import { httpInterceptorProviders } from './shared/http-interceptors';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { UsersManagementComponent } from './components/users/users-management/users-management.component';
import { UsersDeleteComponent } from './components/users/users-delete/users-delete.component';
import { UsersAddComponent } from './components/users/users-add/users-add.component';
import { UserUpdatePasswordComponent } from './components/users/user-update-password/user-update-password.component';
import { UserEditComponent } from './components/users/user-edit/user-edit.component';
import { HistoryComponent } from './components/history/history.component';
import { UserUpdateComponent } from './components/users/user-update/user-update.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RecordsComponent } from './components/records/records.component';
import { ContainersComponent } from './components/containers/containers.component';
import { ContainerProgressComponent } from './components/containers/container-progress/container-progress.component';
import { OpendialogNewContainerComponent } from './components/containers/opendialog-new-container/opendialog-new-container.component';
import { OpendialogDeleteContainerComponent } from './components/containers/opendialog-delete-container/opendialog-delete-container.component';
import { OpendialogInfosContainerComponent } from './components/containers/opendialog-infos-container/opendialog-infos-container.component';
import { InitFilterRecordsService } from '@services/init-filter-records/init-filter-records.service';
import localeFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';
import { ChartInputTextileComponent } from './components/dashboard/chart-input-textile/chart-input-textile.component';
import { ChartsModule } from 'ng2-charts';
import { ChartSortedWeightComponent } from './components/dashboard/chart-sorted-weight/chart-sorted-weight.component';
import { ChartCurvedItemsComponent } from './components/dashboard/chart-curved-items/chart-curved-items.component';
import { ChartSalesFcComponent } from './components/dashboard/chart-sales-fc/chart-sales-fc.component';
import { ChartOkilosComponent } from './components/dashboard/chart-okilos/chart-okilos.component';
import { ChartClicoteComponent } from './components/dashboard/chart-clicote/chart-clicote.component';
import { OpendialogConfirmDeleteRecordComponent } from './components/records/opendialog-confirm-delete-record/opendialog-confirm-delete-record.component';


export function tokenGetterFactory(): string {
  return localStorage.getItem(environment.tokenKey);
}
export function TranslateLoaderFactory(http: HttpClient): ApiTranslateLoader {
  return new ApiTranslateLoader(http);
}

registerLocaleData(localeFr, 'fr');


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    UsersManagementComponent,
    UsersDeleteComponent,
    UsersAddComponent,
    UsersAddComponent,
    UserUpdatePasswordComponent,
    UserEditComponent,
    HistoryComponent,
    UserUpdateComponent,
    RecordsComponent,
    ContainersComponent,
    ContainerProgressComponent,
    OpendialogNewContainerComponent,
    OpendialogDeleteContainerComponent,
    OpendialogInfosContainerComponent,
    ChartInputTextileComponent,
    ChartSortedWeightComponent,
    ChartCurvedItemsComponent,
    ChartSalesFcComponent,
    ChartOkilosComponent,
    ChartClicoteComponent,
    OpendialogConfirmDeleteRecordComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FontAwesomeModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AuthModule,
    MainModule,
    SharedModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    ChartsModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetterFactory,
        allowedDomains: [environment.apiDomain],
        disallowedRoutes: [environment.identityApiUrl + 'connect/token']
      }
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: TranslateLoaderFactory,
        deps: [HttpClient]
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: ApiMissingTranslationHandler
      }
    })

  ],
  providers: [
    appInitializerProviders,
    httpInterceptorProviders,
    InitFilterRecordsService,
    { provide: LOCALE_ID, useValue: 'fr' }

  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
